import { combineReducers } from 'redux'

import orderPageFilters from './orderPageFilters'
import publicationDeadlines from './publicationDeadline'
import reportPageFilters from './reportPageFilters'
import templatePageFilters from './templatePageFilters'
import templatePageStats from './templatePageStats'

export default combineReducers({
  orderPageFilters,
  publicationDeadlines,
  reportPageFilters,
  templatePageFilters,
  templatePageStats,
})
